// extracted by mini-css-extract-plugin
export var videoHero = "_dz-4";
export var videoHeroImage = "_dz-5";
export var videoHeroOverlay = "_dz-6";
export var videoHeroSubtitle = "_dz-8";
export var videoHeroText = "_dz-7";
export var videoLauncher = "_dz-0";
export var videoLauncherIcon = "_dz-1";
export var videoLauncherSubtitle = "_dz-3";
export var videoLauncherTitle = "_dz-2";
export var videoPlayer = "_dz-a";
export var videoPlayerWrap = "_dz-9";